import { Heading, Tooltip } from "@stacklet/ui";

import { useHasScopePermission } from "app/hooks";

import { CreateNonSsoUser } from "../users/user-list/components/actions/CreateNonSsoUser";

/**
 * Action bar for the Users settings page: the page title, and the create user
 * action. Search lives in the directory below (per view).
 */
export function UsersActionBar() {
  const hasPermission = useHasScopePermission();
  const hasSystemEditPermission = hasPermission("system", "EDIT");

  return (
    <div className="mb-xl flex items-center justify-between gap-md">
      <Heading level={2}>Users</Heading>
      <Tooltip
        title={
          hasSystemEditPermission
            ? ""
            : "You need system edit permissions to create a user"
        }
        asChild
      >
        <span>
          <CreateNonSsoUser />
        </span>
      </Tooltip>
    </div>
  );
}
